import React from 'react';
import PropTypes from 'prop-types';

import ResultsModal from 'react/views/generic/ResultsModal';
import './preformattedModalServerStyles.less';
import './contentCafeStyles.less';

function PreformattedModal(props) {
	let content;
	let title="Results";

	if(props.item && props.item.__html) {
		content = <div style={props.modalStyle} dangerouslySetInnerHTML={props.item} />;
		title = props.item.name;
	}

	return (
		<ResultsModal
			modalTitle={title}
			isLoading={props.isLoading || false}
			isOpen={props.isOpen}
			close={props.onClose}
			isScrollable>
			{content}
		</ResultsModal>
	);
}

PreformattedModal.propTypes = {
	isLoading: PropTypes.bool,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	item: PropTypes.shape({
		name: PropTypes.string,
		__html: PropTypes.string
	}),
}

export default PreformattedModal;



// WEBPACK FOOTER //
// ./src/react/views/generic/PreformattedModal.jsx